import React from 'react';
import { Modal, ModalBody } from 'reactstrap';

import { TestimonialType, CreateAccountFlowType } from './types';
import CreateAccountModalContentArea from './CreateAccountModalContentArea/CreateAccountModalContentArea';
import CreateAccountModalFormArea from './CreateAccountModalFormArea/CreateAccountModalFormArea';
import './CreateAccountModal.scss';

type Props = {
  testimonial?: TestimonialType;
  showCompletedSteps?: boolean;
  title?: string;
  description?: string;
  createAccountFlowType?: CreateAccountFlowType;
  showOAuthButtons?: boolean;
  cannotSignIntoGoogle?: boolean;
};

function CreateAccountModal({
  testimonial,
  showCompletedSteps,
  title,
  description,
  createAccountFlowType,
  showOAuthButtons,
  cannotSignIntoGoogle,
}: Props) {
  return (
    <Modal centered isOpen className="create-account-modal">
      <ModalBody className="create-account-modal-content p-0">
        <div className="d-flex flex-column flex-lg-row">
          <CreateAccountModalContentArea testimonial={testimonial} showCompletedSteps={showCompletedSteps} />
          <div className="create-account-modal-form-area p-5">
            <CreateAccountModalFormArea
              title={title}
              description={description}
              createAccountFlowType={createAccountFlowType}
              showOAuthButtons={showOAuthButtons}
              cannotSignIntoGoogle={cannotSignIntoGoogle}
            />
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default CreateAccountModal;
